/* @flow weak */
import * as React from 'react';
import enumerate from 'lib/enumerate';
import Container from 'components/Container.jsx';
import TitleHeader from 'components/TitleHeader.jsx';
import View from 'components/View.jsx';
import { pollAndRefresh } from 'setup/utils/rosterPoll';
import trackView from 'lib/trackView';
import Redirect from 'components/Redirect.jsx';

export const STATUS = enumerate(['loading', 'complete']);

type State = {
  status: string,
};

type Props = {
  statusEndpoint: string,
};

export class SetupRosterConfirmPoll extends React.Component<Props, State> {
  state: State = {
    status: STATUS.loading,
  };

  componentDidMount() {
    const markComplete = () => this.setState({ status: STATUS.complete });
    pollAndRefresh(this.props.statusEndpoint)
      .then(markComplete)
      .catch(err => {
        console.warn(err, err && err.stack);
        console.error('failed to handle pollAndRefresh in SetupRosterConfirmPoll');
        markComplete();
      });
  }

  render() {
    const loading = this.state.status === STATUS.loading;
    const header = 'Almost done…';
    const subtext = 'We’re updating your classes now.';

    if (loading) {
      return (
        <View className="SetupRosterConfirmPoll" scroll>
          <Container size="medium">
            <TitleHeader title={header} subtext={subtext} textAlign="left" />
          </Container>
        </View>
      );
    } else {
      return <Redirect to="/landing" />;
    }
  }
}

export default trackView(SetupRosterConfirmPoll, 'sis_roster_confirm_poll');
